import { IContractDate as MainModel } from "@/models/marketData";
import { createBaseStore } from "./baseStore";

export const useContractDateStore = createBaseStore<MainModel, {}>(
  "contractDate",
  "contractDateSeq",
);
